import styled from 'styled-components';

import Button from '@components/Button/next';

export const BannerWrapper = styled.div<{ showInfoText?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 11px 0 11px 20px;
  margin-bottom: 5px;
  background-color: ${({ theme }) => theme.palette.white};
  border-top: 1px solid ${({ theme }) => theme.palette.lynxWhite};
  border-radius: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: ${({ showInfoText }) => (showInfoText ? 'column' : 'row')};
    padding: ${({ showInfoText }) =>
      showInfoText ? '11px 0 11px 20px' : '11px 0 11px 0'};
  }
`;

export const ImageContainer = styled.div`
  width: 46px;
  height: 32.79px;
`;

export const InfoWrapper = styled.div`
  display: flex;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: flex-end;
  }
`;

export const InfoText = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;

  font-size: 16px;
`;

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0px;
  border: none;
  font-size: 16px;
  font-weight: 400;
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.scooter};
  box-shadow: none;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: flex-start;
    align-items: flex-start;
  }

  &:hover,
  &:active,
  &:focus {
    background-color: ${({ theme }) => theme.palette.white};
    color: ${({ theme }) => theme.palette.scooter};
    box-shadow: none;
  }
`;
